module.exports = __webpack_public_path__ + "img/gsb24.4b2d8b18.png";